export default __webpack_public_path__ + "static/media/report_confidently.b0f933f7.svg";